<template>
  <div class="col-md-4 shadow">
    <vs-list>
      <vs-list-item
        v-for="(participant, index) in participants"
        :key="index"
        icon="description"
        :title="participant.nombre"
        :subtitle="participant.tipo === SIGNER ? 'Firmante' : 'Visador'"
      />
    </vs-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConventionAuthors',
  data() {
    return {
      SIGNER: 1,
      CERTIFIER: 2
    };
  },
  computed: {
    ...mapGetters('Dnts', ['detailsFile']),
    participants() {
      return this.detailsFile.docDigitalParticipantes;
    }
  }
};
</script>

<style>

</style>
